import {
  gql
} from "@apollo/client";
import { CHARGER_ASSET_DETAILS_FRAGMENT } from "gql/fragments";

export const CHARGERS = gql`
  ${CHARGER_ASSET_DETAILS_FRAGMENT}
  query Chargers($chargers_n: Int, $after: String, $chargers_where: InputSalesforceChargerOperators) {
    chargers(n: $chargers_n, after: $after, where: $chargers_where, ) @connection(key: "paginatedChargers") {
      edges {
        cursor
        node {
          salesforce_details: salesforce_details {
            ...ChargerAssetDetails
          }
          assetDetails: salesforce_details {
            ...ChargerAssetDetails
          }
          details: salesforce_details {
            ...ChargerAssetDetails
          }
          serial
          vpn_status {
            connections {
              allowed_ips
            }
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      totalCount
    }
  }
`;

export const GET_CHARGER_CONFIG = gql`
  query Get_charger_config($n: Int, $where: InputSalesforceChargerOperators) {
    chargers(n: $n, where: $where) @connection(key: "chargerConfig") {
      edges {
        node {
          serial
          charger_configuration {
            change_status
            changed_timestamp
            charger_value
            config_key
            readonly
            set_value
          }
        }
      }
    }
  }
`;

export const LIST_PENDING_CONFIGS = gql`
  query List_pending_configs($n: Int, $chargers_where: InputSalesforceChargerOperators, $config_where: InputChargerConfigurationItemOperators) {
    chargers_config_pending(n: $n) @connection(key: "pendingConfigs") {
      edges {
        node {
          charger_configuration {
            change_status
            changed_timestamp
            charger_value
            config_key
            serial
            set_value
          } 
        }
      }
    }
  }
`;

export const CHANGE_CONFIGURATION = gql`
  mutation Change_configuration($payload: InputChangeConfigurationRequestPayload!, $serial: String) {
    charger_ocpp_mutation {
      change_configuration(payload: $payload, serial: $serial) {
        payload {
          status
        }
      }
    }
  }
`;

export const UPDATE_FIRMWARE = gql`
  mutation Update_firmware($payload: InputUpdateFirmwareRequestPayload, $serial: String) {
    charger_ocpp_mutation {
      update_firmware(payload: $payload, serial: $serial) {
        payload {
          status
        }
      }
    }
  }
`;
